import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// API URL: use env var for preview, window.location.origin for production/custom domains
export const API_URL = (() => {
  const envUrl = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window !== "undefined" && envUrl) {
    const currentHost = window.location.hostname;
    // If we're on preview domain, use the env URL
    if (currentHost.includes("preview.emergentagent.com")) {
      return envUrl;
    }
    // If on localhost, use env URL
    if (currentHost === "localhost" || currentHost === "127.0.0.1") {
      return envUrl;
    }
    // For any other domain (production, custom domain), use same origin
    return window.location.origin;
  }
  return envUrl;
})();

// Format API error detail for display
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Italian month names
export const MONTH_NAMES = [
  "", "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
];

// Status colors
export const STATUS_COLORS = {
  lavoro: { bg: "#0EA5E9", text: "#FFFFFF", label: "Lavoro", cellLabel: "Lavoro" },
  riposo: { bg: "#10B981", text: "#FFFFFF", label: "Riposo", cellLabel: "Riposo" },
  ferie: { bg: "#F59E0B", text: "#FFFFFF", label: "Ferie", cellLabel: "Ferie" },
  malattia: { bg: "#EF4444", text: "#FFFFFF", label: "Malattia", cellLabel: "Malatt" },
  "104": { bg: "#8B5CF6", text: "#FFFFFF", label: "104", cellLabel: "104" },
  permesso_lutto: { bg: "#374151", text: "#FFFFFF", label: "Lutto", cellLabel: "Lutto" },
  permesso_matrimoniale: { bg: "#EC4899", text: "#FFFFFF", label: "Matrimonio", cellLabel: "Matrim" },
  rol: { bg: "#6366F1", text: "#FFFFFF", label: "ROL", cellLabel: "ROL" },
  congedo_parentale: { bg: "#F97316", text: "#FFFFFF", label: "Congedo Parentale", cellLabel: "Cong P" }
};

// Location types
export const LOCATION_TYPES = [
  { value: "hotel", label: "Hotel" },
  { value: "ristorante", label: "Ristorante" },
  { value: "lavanderia", label: "Lavanderia" },
  { value: "appalto", label: "Appalto" }
];

// Get days in month
export function getDaysInMonth(year, month) {
  return new Date(year, month, 0).getDate();
}

// Format currency
export function formatCurrency(amount) {
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR"
  }).format(amount || 0);
}

// Calculate hours between two times
export function calculateHours(startTime, endTime) {
  if (!startTime || !endTime) return 0;
  const [startH, startM] = startTime.split(":").map(Number);
  const [endH, endM] = endTime.split(":").map(Number);
  const startMinutes = startH * 60 + startM;
  const endMinutes = endH * 60 + endM;
  let diff = endMinutes - startMinutes;
  if (diff <= 0) diff += 24 * 60; // night shift crossing midnight
  return Math.round((diff / 60) * 100) / 100;
}
